<template>
  <div class="footer_setting tab_content" @mousedown.stop>
    <my_background
      titleWidth="90"
      :title="$t('view_left_sidebar_page_setting_footer_setting_253')"
      hiddenIsShow="false"
      :radioValue.sync="footer_background.radio_val"
      :bgType.sync="footer_background.custom.type"
      :imgUrl.sync="footer_background.custom.img"
      :imgScale.sync="footer_background.custom.img_scale"
      :tileEffect.sync="footer_background.custom.tile_effect"
      :imgPos.sync="footer_background.custom.background_position"
      :colorValue.sync="footer_background.custom.color"
      @imgScaleChange="
        img_scale => {
          let options = this.$store.state.options.backGroundImageList;
          footer_background.custom.background_size = options[img_scale].background_size;
          footer_background.custom.background_repeat = options[img_scale].background_repeat;
          footer_background.custom.background_position = options[img_scale].background_position;
        }
      "
      @tileEffectChange="
        tile_effect => {
          let options = this.$store.state.options.backGroundImageList;
          footer_background.custom.background_size = options[tile_effect].background_size;
          footer_background.custom.background_repeat = options[tile_effect].background_repeat;
          footer_background.custom.background_position = options[tile_effect].background_position;
        }
      "
    ></my_background>
    <my_radio_new :title="$t('view_left_sidebar_page_setting_footer_setting_254')" titleWidth="90" v-model="copyright.showTag" v-if="copyright" @change="footer_change" class="copyright_information">
      <div slot="expand" class="copyright_expand">
        <el-input v-model="copyright.words" class="copyright_input" size="small" @change="footer_change"></el-input>
      </div>
    </my_radio_new>
    <my_radio_new :title="$t('view_left_sidebar_page_setting_footer_setting_255')" titleWidth="90" v-model="copyright.make_isShow" v-if="copyright" class="copyright_information"></my_radio_new>
    <my_radio
    v-if="$store.state.app.language == 'zh-cn'  
    && $store.state.app.is_inline"
      titleWidth="90"
      :option="$store.state.options.isSHow"
      :title="$t('view_left_sidebar_page_setting_footer_setting_256')"
      :selectValue.sync="$store.state.myRender.common.icp_isShow"
    ></my_radio>
    <!-- <my_radio_new title="隐私政策：" titleWidth="90" v-model="copyright.privacyPolicy" v-if="copyright"></my_radio_new>
    <my_radio_new title="访客授权：" titleWidth="90" v-model="$store.state.myRender.common.visitor_auth" v-if="$store.state.myRender.common.visitor_auth"></my_radio_new> -->
  </div>
</template>

<script>
import i18n from '../../../language/index'

import my_radio_new from "./components/my_radio";

export default {
  name: "footer_setting",
  components: {
    my_radio_new
  },
  data() {
    return {

    };
  },
  computed: {
    footer_background() {
      return this.$store.state.myRender.common.footer_background;
    },
    copyright(){
      let r = null;
      let copyright = this.templet.use_name_find_module('footer','basic_copyright');
      if(copyright){
        r = copyright.data.listArr;
      }
      return r;
    }
  },
  mounted() {
    
  },
  methods: {
    footer_change(){
      this.$store.commit('app/SET_is_change',true)
    }

  }
};
</script>

<style lang="scss">
.footer_setting {
  .copyright_expand {
    margin-left: 74px;
    .copyright_input {
      width: 200px;
    }
  }
  .icon_create {
    display: inline-block;
    width: 20px;
    height: 35px;
    background-image: url("~@/assets/image/mbg01.png");
    background-position: -648px -142px;
    cursor: pointer;
  }
}
.footer_popover_style {
  .popover_content {
    width: 200px;
    height: 260px;
    .title {
      padding-bottom: 10px;
      font-size: 15px;
      border-bottom: 1px solid #e2e3e8;
      span {
        color: #fbba6d;
      }
    }
    .line_title {
      line-height: 55px;
    }
    .line {
      margin-bottom: 14px;
      .icon_check {
        display: inline-block;
        margin-right: 8px;
        width: 14px;
        height: 14px;
        background-image: url("~@/assets/image/mbg01.png");
        background-position: -188px -380px;
        vertical-align: middle;
      }
    }
  }
}
</style>

<style lang="scss">
.footer_setting {
  .pull_down_content > div {
    margin-left: 0 !important;
  }
  .my_radio_layer {
    margin-left: 0;
    margin-right: 0;
  }
  .set_two_level .title {
    // width: 65px !important;
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/footer_setting.vue